export const ETHEREUM = "ETHEREUM";
export const POLYGON = "POLYGON";
export const ARBITRUM = "ARBITRUM";
export const TEZOS = "TEZOS";
export const BASE = "BASE";
export const OPTIMISM = "OPTIMISM";
